import { graphql } from '@prophecy/graphql-types/graphql';
export const DataQualityObservationQuery = graphql(`
  query DataQualityObservations(
    $projectId: Int
    $uid: String
    $startDateFrom: Float
    $startDateTo: Float
    $maxCount: Int
  ) {
    DataQualityObservations(
      projectId: $projectId
      dataSetId: $uid
      startDateFrom: $startDateFrom
      startDateTo: $startDateTo
      maxCount: $maxCount
    ) {
      startDate
      endDate
      status
      fields
      projectId
      projectName
      prophecyJobId
      expectationMsg
      tableName
      columnName
      summary
      prophecyJobName
    }
  }
`);
export const DataQualityFeedbackQuery = graphql(`
  mutation DataQualityObservationFeedback($runId: String!, $runType: String!, $feedback: String!) {
    DataQualityObservationFeedback(runId: $runId, runType: $runType, feedback: $feedback)
  }
`);
export const ConnectorsQuery = graphql(`
  query ConnectorQuery($fabricUID: String!) {
    ListConnectorInFabric(fabricUID: $fabricUID) {
      _id
      name
    }
  }
`);
export const FetchConnectorEventsQuery = graphql(`
  query FetchConnectorEventsQuery(
    $uid: String
    $ownerUID: String
    $maxCount: Int
    $startDateTo: Float
    $startDateFrom: Float
  ) {
    FetchConnectorEvents(
      uid: $uid
      ownerUID: $ownerUID
      maxCount: $maxCount
      startDateTo: $startDateTo
      startDateFrom: $startDateFrom
    ) {
      _id
      status
      created_at
      error_message
    }
  }
`);
